<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: { type: String, default: 'left' },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const OPTIONS = [
  ['left', 'i-lucide-align-left'],
  ['center', 'i-lucide-align-center'],
  ['right', 'i-lucide-align-right'],
];
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span class="text-xs font-medium text-n-slate-11">
      {{ label || t('EMAIL_TEMPLATES.EDITOR.PROPS.ALIGN') }}
    </span>
    <div class="flex w-fit gap-0.5 rounded-lg border border-n-weak p-0.5">
      <button
        v-for="[value, icon] in OPTIONS"
        :key="value"
        type="button"
        class="rounded-md px-2 py-1"
        :class="
          modelValue === value
            ? 'bg-n-brand/10 text-n-brand'
            : 'text-n-slate-11'
        "
        @click="emit('update:modelValue', value)"
      >
        <span :class="icon" class="block size-4" />
      </button>
    </div>
  </div>
</template>
